/**
 * The matches worth showing: the ones a player can actually open.
 *
 * A row without an archived replay has nothing behind it, so rather than
 * design a second, dead-end tile for it, it is not listed at all. Every
 * match played from here on archives at settle, and match_history is a
 * capped recency list, so the unplayable rows are the pre-replay backlog
 * and they age out on their own.
 */
export function replayableMatches(history) {
  return (history || []).filter((m) => m?.hasReplay && m.roomCode);
}

/**
 * The history with one match renamed and/or (un)pinned, re-sorted the way
 * the server lists it: pinned first, then newest first. The optimistic
 * client-side twin of PUT /matches/:roomCode/history.
 */
export function applyMatchMetaPatch(history, roomCode, patch) {
  const next = (history || []).map((m) => (m.roomCode === roomCode
    ? {
      ...m,
      customName: patch.name !== undefined ? (patch.name.trim() || null) : m.customName,
      pinned: patch.pinned !== undefined ? patch.pinned : m.pinned,
    }
    : m));
  next.sort((a, b) => (b.pinned === true) - (a.pinned === true)
    || new Date(b.playedAt || 0) - new Date(a.playedAt || 0));
  return next;
}
